// Module
var code = "<wt-generic-search-bar criteria=\"vm.criteria\" items=\"vm.items\" filtered-items=\"vm.filteredItems\" form-controller=\"vm.formController\" on-change=\"vm.change(value)\" placeholder=\"{{vm.placeholder}}\" property-name=\"vm.propertyName\" search-string=\"vm.model\"> </wt-generic-search-bar>";
// Exports
module.exports = code;